import { useEffect, useRef } from "react";

function useFocusTrap(
  componentRef,
  componentChildren = null,
  focusableElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
) {
  const firstFocusableElement = useRef();
  const lastFocusableElement = useRef();

  function handleTabBehaviour(event) {
    if (event.shiftKey) {
      if (document.activeElement === firstFocusableElement.current) {
        event.preventDefault();
        lastFocusableElement.current.focus();
      }
    } else if (document.activeElement === lastFocusableElement.current) {
      event.preventDefault();
      firstFocusableElement.current.focus();
    }
  }

  useEffect(() => {
    if (componentRef.current) {
      const elements = componentRef.current.querySelectorAll(focusableElements);
      // eslint-disable-next-line prefer-destructuring
      firstFocusableElement.current = elements[0];
      lastFocusableElement.current = elements[elements.length - 1];
    }
  }, [componentChildren, componentRef]);

  return { handleTabBehaviour, firstFocusElementRef: firstFocusableElement };
}

export { useFocusTrap };
